import { Link } from 'react-router-dom';
import { useState, useLayoutEffect } from 'react';
import PageHero from '../components/PageHero';

// `specialty` renders as a teal label under each stylist's name. Empty = no
// label shown. Fill each in with the stylist's own answer when they reply.
const teamMembers = [
  { name: 'Alysa', image: '/images/alysa.jpg', handle: 'alysaxglambox', instagram: 'https://instagram.com/alysaxglambox', specialty: '' },
  { name: 'Victoria', image: '/images/victoria.jpg', handle: 'haairbyvictoriaa', instagram: 'https://www.instagram.com/haairbyvictoriaa/', specialty: '' },
  { name: 'Melissa', image: '/images/melissa.jpg', handle: 'mmh_hair', instagram: 'https://www.instagram.com/mmh_hair/', specialty: '' },
  { name: 'Kayla', image: '/images/kayla.jpg', handle: 'kaylaarchive', instagram: 'https://www.instagram.com/kaylaarchive/', specialty: '' },
  { name: 'Stacie', image: '/images/stacie.jpg', handle: 'styled.bystacie', instagram: 'https://www.instagram.com/styled.bystacie/', specialty: '' },
  { name: 'Lorena', image: '/images/lorena.jpg', handle: 'vampiravivids', instagram: 'https://www.instagram.com/vampiravivids/', specialty: '' },
  { name: 'Karlee', image: '/images/karlee.jpg', handle: 'hairbyxkarlee', instagram: 'https://www.instagram.com/hairbyxkarlee/', specialty: '' },
];

// Fisher-Yates shuffle; returns a new array, does not mutate the input.
function shuffle(list) {
  const a = list.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const Team = () => {
  // The prerender crawler (puppeteer) and every visitor's first hydration render
  // use the canonical order above, so the baked HTML and the initial client
  // render match and hydration stays clean. After hydration, real visitors
  // shuffle the roster so the stylist order rotates on each visit (fair top
  // billing for independent booth renters). useLayoutEffect reorders before the
  // browser paints, so there's no visible flash. The crawler sets
  // navigator.webdriver, so the static HTML keeps the canonical order.
  const [members, setMembers] = useState(teamMembers);
  useLayoutEffect(() => {
    if (typeof navigator !== 'undefined' && navigator.webdriver) return;
    setMembers(shuffle(teamMembers));
  }, []);

  return (
  <div className="page">
    <PageHero kicker="The team" title="The stylists who make The Loft, The Loft.">
      Every stylist here is an independent pro with their own chair, their own
      portfolio, and their own book. Find the one whose work looks like the hair
      you want, then reach out on Instagram to set up your appointment.
    </PageHero>

    <section className="section">
      <div className="container">
        <div className="team-grid">
          {members.map((member, i) => (
            <a
              className="stylist reveal"
              data-reveal={(i % 3) * 80}
              key={member.name}
              href={member.instagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="stylist__img arch">
                <img src={member.image} alt={`${member.name}, stylist at The Loft Salon`} loading="lazy" />
              </div>
              <div className="stylist__meta">
                <h3>{member.name}</h3>
                <span className="stylist__handle">{`@${member.handle}`}</span>
              </div>
              {member.specialty && (
                <p className="stylist__specialty">{member.specialty}</p>
              )}
              <span className="stylist__cta">
                View work & book <span className="arrow">→</span>
              </span>
            </a>
          ))}
        </div>

        <div className="team-fallback reveal">
          <p>New here, or not sure which stylist to book with?</p>
          <Link to="/contact" className="btn btn--outline">
            Contact the salon and we'll match you
          </Link>
        </div>
      </div>
    </section>

    <section className="section--tight section--dark grain cta-band">
      <div className="container cta-band__inner">
        <div className="reveal">
          <span className="kicker">Join us</span>
          <h2>Want to be part of our team?</h2>
          <p className="lede">
            We rent full-time and part-time chairs to licensed stylists who want
            a warm room and the freedom to run their own book.
          </p>
        </div>
        <Link to="/booths" className="btn btn--primary reveal" data-reveal="120">
          Booth rental details
        </Link>
      </div>
    </section>
  </div>
  );
};

export default Team;
